import styled from 'styled-components'

export const StyleGroundingOverview = styled.div`
  .custom-select:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
  .form-control:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
  .section-name {
    min-width: 12rem;
  }
  min-height: 10rem;
`
